/** Resolves an API path beneath the environment's deployment mount (`/heydex/`). */
export function environmentEndpointUrl(baseUrl: string, pathname: string): string {
  const base = new URL(baseUrl);
  base.pathname = `${base.pathname.replace(/\/+$/, "")}/`;
  base.search = "";
  base.hash = "";
  return new URL(pathname.replace(/^\//, ""), base).toString();
}
